(ns minorodata.users.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.app.utils :as app.utils]))

(declare ->client-data
         ->client-roles
         ->notification-preferences
         ->role-warehouse-credentials
         ->searchable-user
         ->user
         ->warehouse-credentials)

(defn prepare-user [user-from-server]
  (let [token-data (app.utils/parse-token (:session-token user-from-server))]
    (-> user-from-server
        (dissoc :role)
        (merge token-data)
        (update :permissions #(mapv keyword %)))))


(m/defmodel user
  {:uid           [::m/string ::m/req ::m/identity "Unique ID (not a valid UUID)"]
   :cid           [::m/string ::m/req "Client ID"]
   :exp           [::m/number "Token expiration time"]
   :user          [::m/string ::m/req ::m/not-empty "Unique username"]
   :session-token [::m/string ::m/req ::m/not-empty "Session token"]
   :roles         {::m/type        ::m/string
                   ::m/cardinality ::m/many
                   ::m/doc         "User roles"}
   :features      {::m/type        ::m/string
                   ::m/cardinality ::m/many
                   ::m/doc         "Available features"}
   :role-id       [::m/string ::m/nilable "Role id"]
   :permissions   {::m/type        ::m/string
                   ::m/cardinality ::m/many
                   ::m/doc         "Role permissions"}}
  {:singleton true})


(m/defmodel user-account
  {:id         [::m/string ::m/req ::m/identity "User ID"]
   :user-name  [::m/string ::m/req "Username"]
   :login-name [::m/string ::m/req "Login"]
   :role       [::m/string ::m/req "Role"]
   :role-id    [::m/string "User Role Id"]
   ;:is-sso     [::m/bool ::m/nilable "Is SSO"]
   :is-blocked [::m/bool ::m/nilable "Is Blocked"]})


(m/defmodel client-data
  {:cid        [::m/string ::m/req ::m/identity "Client ID"]
   :clientname [::m/string ::m/nilable "Client Name"]
   :hostname   [::m/string ::m/nilable "Hostname"]
   :timezone   [::m/string ::m/nilable "Timezone"]
   :users      {::m/type         ::m/ref
                ::m/is-component ::m/component
                ::m/nilable      true
                ::m/ref-type     user-account
                ::m/cardinality  ::m/many
                ::m/doc          "Client's user accounts"}})

(m/defmodel client-roles
  {:cid         [::m/string ::m/req ::m/identity "Client ID"]
   :roles       {::m/type        ::m/map
                 ::m/cardinality ::m/many
                 ::m/doc         "List of roles"}
   :permissions {::m/type        ::m/string
                 ::m/cardinality ::m/many
                 ::m/doc         "List of permissions"}})


(m/defmodel notification-preferences
  {:preferences                 [::m/vector "Array of preferences"]

   :slack-webhook               [::m/string ::m/nilable "Webhook URL"]
   :slack-transforms-success    [::m/bool]
   :slack-transforms-failure    [::m/bool]
   :slack-extracts-success      [::m/bool]
   :slack-extracts-failure      [::m/bool]

   :ms-teams-webhook            [::m/string ::m/nilable "Webhook URL"]
   :ms-teams-webhook-workflows  [::m/bool "Flag indicating that new Teams Workflows are used"]
   :ms-teams-transforms-success [::m/bool]
   :ms-teams-transforms-failure [::m/bool]
   :ms-teams-extracts-success   [::m/bool]
   :ms-teams-extracts-failure   [::m/bool]

   :generic-webhook             [::m/string ::m/nilable "Webhook URL"]
   :generic-transforms-success  [::m/bool]
   :generic-transforms-failure  [::m/bool]
   :generic-extracts-success    [::m/bool]
   :generic-extracts-failure    [::m/bool]}
  {:singleton true})


(m/defmodel searchable-user
  {:id                                 [::m/string ::m/identity "User id"]
   :username                           [::m/string "User name"]
   :email                              [::m/string "User login / email"]
   :active                             [::m/bool]})

(m/defmodel warehouse-credentials
  {:user-id             [::m/string ::m/req ::m/identity "User id"]
   :credentials         [::m/map ::m/req "Role, User, Password"]
   :enforce-credentials [::m/bool]})

(m/defmodel role-warehouse-credentials
  {:role-id             [::m/string ::m/req ::m/identity "Role id"]
   :credentials         [::m/map ::m/req "Role, User, Password"]})
